var _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_135_105493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5C12.5 5.77614 12.7239 6 13 6C13.2761 6 13.5 5.77614 13.5 5.5V3.5H15.5C15.7761 3.5 16 3.27614 16 3C16 2.72386 15.7761 2.5 15.5 2.5H13.5V0.5C13.5 0.223857 13.2761 0 13 0C12.7239 0 12.5 0.223857 12.5 0.5V2.5H10.5C10.2239 2.5 10 2.72386 10 3C10 3.27614 10.2239 3.5 10.5 3.5H12.5V5.5Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2.5C3.79822 2.5 1 5.29822 1 8.75C1 12.2018 3.79822 15 7.25 15C10.7018 15 13.5 12.2018 13.5 8.75C13.5 8.47386 13.7239 8.25 14 8.25C14.2761 8.25 14.5 8.47386 14.5 8.75C14.5 12.7541 11.2541 16 7.25 16C3.24594 16 0 12.7541 0 8.75C0 4.74594 3.24594 1.5 7.25 1.5C7.52614 1.5 7.75 1.72386 7.75 2C7.75 2.27614 7.52614 2.5 7.25 2.5Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99961 8.74995C5.49667 8.74995 5.89961 8.34701 5.89961 7.84995C5.89961 7.35289 5.49667 6.94995 4.99961 6.94995C4.50255 6.94995 4.09961 7.35289 4.09961 7.84995C4.09961 8.34701 4.50255 8.74995 4.99961 8.74995Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50102 8.74995C9.99807 8.74995 10.401 8.34701 10.401 7.84995C10.401 7.35289 9.99807 6.94995 9.50102 6.94995C9.00396 6.94995 8.60102 7.35289 8.60102 7.84995C8.60102 8.34701 9.00396 8.74995 9.50102 8.74995Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98237 10.8787C4.84287 10.6403 4.53659 10.5602 4.29828 10.6997C4.05996 10.8392 3.97985 11.1455 4.11935 11.3838C4.41616 11.8909 4.92491 12.254 5.46863 12.4881C6.01795 12.7247 6.64803 12.85 7.25086 12.85C7.8537 12.85 8.48377 12.7247 9.03309 12.4881C9.57681 12.254 10.0856 11.8909 10.3824 11.3838C10.5219 11.1455 10.4418 10.8392 10.2034 10.6997C9.96513 10.5602 9.65885 10.6403 9.51935 10.8787C9.36616 11.1404 9.06252 11.3867 8.63755 11.5697C8.21818 11.7503 7.72325 11.85 7.25086 11.85C6.77847 11.85 6.28355 11.7503 5.86418 11.5697C5.4392 11.3867 5.13556 11.1404 4.98237 10.8787Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_135_105493)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#6E7680"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBadge);
export default __webpack_public_path__ + "static/media/addBadge.0b6d79e2eb990b1ecaa6634157c19077.svg";
export { ForwardRef as ReactComponent };